import { backgroundColor, whiteColor, dangerColor, secondaryColor } from 'assets/jss/material-dashboard-pro-react';

const cardPadding = {
	fullWidth: ['8px', '25px', '16px', '170px'],
	fitContent: ['10px', '10px', '10px', '100px'],
};

const paddingTop = (fullWidth) => {
	return fullWidth ? cardPadding.fullWidth[0] : cardPadding.fitContent[0];
};

const paddingRight = (fullWidth) => {
	return fullWidth ? cardPadding.fullWidth[1] : cardPadding.fitContent[1];
};

const paddingBottom = (fullWidth) => {
	return fullWidth ? cardPadding.fullWidth[2] : cardPadding.fitContent[2];
};

const paddingLeft = (fullWidth) => {
	return fullWidth ? cardPadding.fullWidth[3] : cardPadding.fitContent[3];
};

const donate = (theme) => ({
	donateWrapper: {
		width: '100%',
		display: 'block',
		position: 'relative',
		backgroundColor: backgroundColor[0],
	},
	exposedCard: {
		display: 'flex',
		width: 122,
		boxShadow: `0 4px 4px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px ${secondaryColor[0]}`,
		position: 'absolute',
		left: 0,
		margin: 0,
		minHeight: 56,
		[theme.breakpoints.down('md')]: {
			left: 0,
			top: -8,
		},
		[theme.breakpoints.up('lg')]: {
			bottom: -8,
		},
	},
	exposedCardBody: {
		padding: 8,
		paddingTop: 36,
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'row',
	},
	exposedCardTitle: {
		paddingTop: 4,
		display: 'flex',
		alignItems: 'flex-end',
	},
	backgroundCard: {
		marginLeft: 'auto',
		width: 'calc(100% - 40px)',
		marginTop: 16,
	},
	backgroundCardBody: ({ fullWidth }) => ({
		display: 'flex',
		alignItems: 'center',
		paddingRight: paddingRight(fullWidth),
		paddingLeft: paddingLeft(fullWidth),
		paddingTop: paddingTop(fullWidth),
		paddingBottom: paddingBottom(fullWidth),
		backgroundColor: backgroundColor[0],
		[theme.breakpoints.down('xs')]: {
			paddingLeft: 25,
			paddingTop: 90,
			flexDirection: 'column',
			alignItems: 'inherit',
		},
	}),
	backgroundCardActions: {
		'& label': {
			marginLeft: -11,
		},
		flex: 1,
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		[theme.breakpoints.down('xs')]: {
			paddingRight: 0,
		},
	},
	donateButton: {
		margin: 0,
	},
	closeWrapper: ({ fullWidth }) => ({
		margin: 0,
		position: 'absolute',
		right: paddingRight(fullWidth),
		[theme.breakpoints.down('xs')]: {
			top: paddingTop(fullWidth),
		},
	}),
	textWrapper: {
		flex: 2,
	},
	iconWrapper: ({ fullWidth }) => ({
		textAlign: fullWidth ? 'right' : 'left',
		color: whiteColor,
		position: 'absolute',
		top: 8,
		right: 8,
	}),
	redIcon: {
		color: `${dangerColor[0]}!important`,
	},
	selectedDonation: {
		marginRight: 16,
	},
	charityNameWrapper: {
		margin: 'auto 0',
		[theme.breakpoints.only('xs')]: {
			display: 'none',
		},
	},
	donationWrapper: {
		backgroundColor: backgroundColor[0],
		width: 'calc(100% + 24px)',
		position: 'relative',
		left: -24,
		marginTop: 40,
		[theme.breakpoints.up('sm')]: {
			'& > div': {
				width: '80%',
				margin: '0 auto',
			},
		},
		[theme.breakpoints.only('xs')]: {
			width: '100%!important',
			left: '0!important',
		},
	},
	thankYouCard: {
		left: 'calc(25% - 142px)',
		[theme.breakpoints.only('xs')]: {
			left: '0',
		},
	},

	thankYouContainer: {
		position: 'relative',
		width: 'calc(100% + 24px)',
		left: -24,
		backgroundColor: backgroundColor[0],
		padding: '8px 0',
		marginTop: 36,
		[theme.breakpoints.only('xs')]: {
			width: '100%',
			left: 0,
		},
	},
	thankYouContent: {
		padding: '8px 16px',
		display: 'flex',
		borderRadius: 4,
		backgroundColor: 'aquamarine',
		width: '50%',
		margin: 'auto',
		[theme.breakpoints.only('xs')]: {
			width: '70%',
			marginTop: 48,
		},
	},
	thankYouValue: {
		minWidth: 100,
		margin: 'auto 0 auto auto',
		'& > p': {
			marginTop: '2px',
		},
		[theme.breakpoints.up('sm')]: {
			textAlign: 'right',
		},
	},
});

export default donate;
